export default [
  {
    path: '',
    name: 'recharge_orders',
    component: () => import('./List'),
  },
]
